import { z } from 'zod';

import { CreateLoanRow } from '@willow/types-iso';

import { getParsedFields } from '../CreateLoanCrossFieldParser';

export const validatePaymentFrequencyFields = (data: CreateLoanRow, ctx: z.RefinementCtx) => {
  const parsed = getParsedFields(data, ['paymentFrequency', 'amortizationType']);

  if (!parsed) {
    return;
  }

  if (parsed.paymentFrequency === 12 || parsed.paymentFrequency == null) {
    return;
  }

  if (parsed.amortizationType === 'arm' || parsed.loanType === 'arm') {
    ctx.addIssue({
      code: 'custom',
      message: `Payment frequency cannot be ${parsed.paymentFrequency} for ARM loans.`,
    });
  }
};
